package com.essntl.features.paymentparameter.ui.paymentparameter

import com.essntl.features.paymentparameter.domain.model.PaymentParameterModel

sealed interface PaymentParameterEvent {
    data object GetPaymentParameters : PaymentParameterEvent
    data class AddPaymentParameter(val p: PaymentParameterModel) : PaymentParameterEvent
    data class EditPaymentParameter(val p: PaymentParameterModel) : PaymentParameterEvent
    data class DeletePaymentParameter(val p: PaymentParameterModel) : PaymentParameterEvent
}